import { connect } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { useEffect } from "react";
import { isNullOrUndefined } from "../../../../utils/functionsUtils";

const ReasonFailedAssignmentModal = ({
    selectedIdAddress,
    showFailedReason,
    handleCloseModal,
    StatusRecordAutomaticAssingmentByIdAddres,
    reduxGetRecordStatusAutomaticAssigment
}) => {
    useEffect(() => {
        if (selectedIdAddress) {
            reduxGetRecordStatusAutomaticAssigment({ idAddress: selectedIdAddress })
        }
    }, [selectedIdAddress]);

    const userData = JSON.parse(window.localStorage.getItem('userData'));

    const formatTimestampByCountry = (currentTimeStamp) => {
        const date = new Date(currentTimeStamp * 1000);

        let timeZone = 'America/Bogota';
        switch (userData.idCountry) {
            case 273:
                timeZone = 'America/Bogota';
                break;
            case 365:
                timeZone = 'America/Mexico_City';
                break;
            case 393:
                timeZone = 'America/Lima';
                break;
            default:
                timeZone = 'UTC';
                break;
        }

        return new Intl.DateTimeFormat('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone,
        }).format(date);
    };

    return (
        <>
            <Modal
                show={showFailedReason}
                onHide={handleCloseModal}
                keyboard={false}
                size="lg"
            >
                <Modal.Header closeButton>
                    {(StatusRecordAutomaticAssingmentByIdAddres.statusRecordList &&
                    StatusRecordAutomaticAssingmentByIdAddres.statusRecordList.length > 0 &&
                    StatusRecordAutomaticAssingmentByIdAddres.statusRecordList[0].idAddress)
                        ? (
                            <Modal.Title>
                                Progreso actual de la orden: {StatusRecordAutomaticAssingmentByIdAddres.statusRecordList[0].idAddress}
                            </Modal.Title>
                        ) : (
                            <Modal.Title>
                                Progreso actual de la orden
                            </Modal.Title>
                        )
                    }
                </Modal.Header>

                <Modal.Body>
                    <div className="card shadow mb-4">
                        <div className="card-body" style={{ overflowX: 'auto', maxWidth: '100%' }}>
                            {
                                (Object.keys(StatusRecordAutomaticAssingmentByIdAddres).length && StatusRecordAutomaticAssingmentByIdAddres.statusRecordList.length > 0)
                                    ?
                                    <table border="1">
                                        <tr>
                                            <th>Estado</th>
                                            <th>Fecha</th>
                                            <th>Razón del fallo</th>
                                            <th>Mensaje de error</th>
                                        </tr>
                                        {(Object.keys(StatusRecordAutomaticAssingmentByIdAddres).length && StatusRecordAutomaticAssingmentByIdAddres.statusRecordList.length > 0) &&
                                            StatusRecordAutomaticAssingmentByIdAddres.statusRecordList.map((recordStatus) => (
                                                <tr key={recordStatus.id}>
                                                    <td className="pr-3">{recordStatus.status}</td>
                                                    <td className="pr-3">{formatTimestampByCountry(recordStatus.timestamp)}</td>
                                                    <td className="pr-3">{recordStatus.failureReason}</td>
                                                    <td className="pr-3">{recordStatus.errorMessage}</td>
                                                </tr>
                                            ))
                                        }
                                    </table>
                                    :
                                    <span>No se encontraron registros asociados a esta orden</span>
                            }
                        </div>
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" className="btn btn-danger" onClick={handleCloseModal}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        StatusRecordAutomaticAssingmentByIdAddres: state.addressToAutomaticAssigmentState.StatusRecordAutomaticAssingmentByIdAddres,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetRecordStatusAutomaticAssigment: (payload) =>
            dispatch({
                type: "GetRecordStatusAutomaticAssigment",
                value: payload,
            }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReasonFailedAssignmentModal);